module.exports = __webpack_public_path__ + "static/media/heavy-bleeding-OFF.91cf55bf.png";